var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.authenticated)?_c('Auth',{attrs:{"loading":_vm.loading,"handleAuthLink":_vm.openAuth}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }